import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAPI',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
// const SupportTicket = defineAsyncComponent(() => import("@/components/theme/api/SupportTicket.vue"))
const SupportTable = defineAsyncComponent(() => import("@/components/theme/api/SupportTable.vue"))
let desc = ref<string>("List of Accounts and API Status Of Customers")

return (_ctx: any,_cache: any) => {
  const _component_SupportTicket = _resolveComponent("SupportTicket")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card3), {
        colClass: "col-sm-12 ",
        title: "API Accounts Overview",
        headerTitle: "true",
        cardhaderClass: "title-header",
        text: "true",
        desc: _unref(desc)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SupportTicket),
          _createVNode(_unref(SupportTable))
        ]),
        _: 1
      }, 8, ["desc"])
    ])
  ]))
}
}

})